const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the user track display component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('userTrackDisplay', ['Application', function (Application) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        item: '@'
      },
      template: require('../../templates/directives/user-track-display.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.getError = Application.notifications.getError;
        self.getSuccess = Application.notifications.getSuccess;

        self.goToTrack = function(id) {
          Application.navigation.goTo('/view/tracks/' + self.userTrack.track._id);
        };

        self.initialize = function () {
          self.userTrack = JSON.parse($scope.item);

          if (self.userTrack.completed_date) {
            self.userTrack.completed_date = moment(self.userTrack.completed_date).format('MMMM Do, YYYY');
            self.userTrack.progress = 100;
          } else if (self.userTrack.progress >= 100 && self.userTrack.updatedAt) {
            self.userTrack.completed_date = moment(self.userTrack.updatedAt).format('MMMM Do, YYYY');
            self.userTrack.progress = 100;
          } else if (self.userTrack.progress >= 100) {
            self.userTrack.completed_date = moment().format('MMMM Do, YYYY');
            self.userTrack.progress = 100;
          } else if (!self.userTrack.progress) {
            self.userTrack.progress = 0;
          }

          if (!self.userTrack.completed_date) {
            self.progress = {'width': self.userTrack.progress + '%'};
          }
          
        };

        $scope.$watch('item', function () {
          if ($scope.item !== undefined) {
            self.initialize();
          }
        });
      }],
      controllerAs: 'display'
    };
  }]);


